const ajax = function (number) {
    const loading = this.$loading({
        lock: true,
        text: '正在加载中...',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      });
    var ss = null
    this.$.ajax({
        url: this.requestUrl + "api/index/xinwenliebiao",
        type: 'POST', // 默认为GET
        dataType: 'json',
        async: false,
        data: {
            timestamp: this.timestamp,
            random: this.numRandom,
            sign: this.mainSign,
            number
        },
        timeout: 5000,
        success: function (result) {
            // console.log(result);
            ss = result;
            loading.close();
          
        },
        error: function () {
            console.log('错误')
            
        }
    })
    return ss
}

export default ajax